import { Box, TextField, styled } from '@mui/material'

export const ActiveHeaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  height: '45px',
  marginLeft: '10px',
}))

export const InactiveHeaderContainer = styled(Box)(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  marginLeft: '10px',
  height: '45px',
}))

export const FullWidthTextField = styled(TextField)(() => ({
  width: '100%',
}))

